import { FormControlLabel } from "@mui/material";

import { useNotificationPrefs, useSetInfoEnabled } from "@/api/notifications";
import OrionSwitch from "@/orion/OrionComponents/OrionSwitch";

interface InformationalToggleProps {
  siteId: string;
}

export function InformationalToggle({ siteId }: InformationalToggleProps) {
  const { data: prefs } = useNotificationPrefs(siteId);
  const setInfoEnabled = useSetInfoEnabled(siteId);

  return (
    <FormControlLabel
      data-testid="notification-info-toggle"
      sx={{ m: 0, gap: 3 }}
      control={
        <OrionSwitch
          size="small"
          checked={prefs?.info_enabled ?? false}
          disabled={setInfoEnabled.isPending}
          onChange={(_, checked) => setInfoEnabled.mutate(checked)}
          inputProps={{ "aria-label": "Show informational" }}
        />
      }
      label="Show informational"
      slotProps={{
        typography: { variant: "body2", color: "text.secondary" },
      }}
    />
  );
}
